import React from 'react';

const AboutUs = () => {
  const missionPoints = [
    {
      title: "Promote Equity and Diversity",
      description: "Create inclusive opportunities for individuals of all backgrounds to explore and celebrate AfroLatin dance, fostering a sense of belonging and mutual respect within the community."
    },
    {
      title: "Enhance Inclusivity and Accessibility",
      description: "Provide accessible dance education, events, and performances that break down barriers to participation, ensuring everyone has the opportunity to experience the joy of dance."
    },
    {
      title: "Support Cultural Reconciliation",
      description: "Honour and share the rich indigenous cultural roots of AfroLatin dance while building connections that promote understanding and reconciliation between diverse communities."
    },
    {
      title: "Cultivate Innovation and Leadership",
      description: "Encourage creativity and leadership within the dance community, empowering members to thrive as performers, educators, event organizers, and cultural ambassadors."
    },
    {
      title: "Build Resilient Communities",
      description: "Strengthen social bonds and resilience by bringing people together through the unifying power of dance, contributing to the cultural vitality of British Columbia."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-light mb-8 text-center">
          About Us
        </h1>
        
        <div className="prose max-w-none">
          <div className="bg-light bg-opacity-10 p-6 rounded-lg mb-12 border border-primary border-opacity-20">
            <h2 className="text-2xl font-semibold text-light mb-4">Our Mission</h2>
            <p className="text-light-gray mb-6 leading-relaxed">
              Rueda de la Vida Dance Society's mission is to enrich British Columbia's vibrant arts 
              and culture landscape by fostering a deep appreciation for AfroLatin dance and its 
              cultural heritage.
            </p>
            <p className="text-light-gray leading-relaxed">
              Through teaching, performance, event hosting, and community engagement, we aim to:
            </p>
          </div>

          <div className="grid gap-8">
            {missionPoints.map((point, index) => (
              <div 
                key={index}
                className="bg-light-gray bg-opacity-5 p-6 rounded-lg border border-primary border-opacity-20 
                         hover:bg-opacity-10 transition-all duration-300 backdrop-blur-sm"
              >
                <h3 className="text-xl font-semibold text-light mb-3 flex items-center">
                  <span className="text-primary mr-3">{index + 1}.</span>
                  {point.title}
                </h3>
                <p className="text-light-gray leading-relaxed">
                  {point.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;